/**
 * The two rosters a team panel can import into or export from — the same pair
 * the Team screen's roster-tab Import and Export menus list
 * (`web/src/pages/Team/index.jsx`).
 */
export type RosterTransferKind = 'players' | 'teamOfficials'

export type RosterTransferDirection = 'import' | 'export'

/** Menu order: players first, then team officials, as on the Team screen. */
export const ROSTER_TRANSFER_KINDS: readonly RosterTransferKind[] = [
  'players',
  'teamOfficials',
]

const EXPORT_PATH: Record<RosterTransferKind, string> = {
  players: 'players/export/csv',
  teamOfficials: 'team-officials/export/csv',
}

export const rosterExportUrl = (
  teamId: string,
  rosterId: string,
  kind: RosterTransferKind
): string => `/teams/${teamId}/rosters/${rosterId}/${EXPORT_PATH[kind]}`

const FILE_SUFFIX: Record<RosterTransferKind, string> = {
  players: 'players',
  teamOfficials: 'team_officials',
}

/**
 * "Mighty Drunks" + players → "Mighty_Drunks_players", exactly the Team
 * screen's `rosterExportFileName` (the download appends `.csv`).
 */
export const rosterExportFileName = (
  teamName: string,
  kind: RosterTransferKind
): string =>
  `${(teamName.trim() || 'team').replace(/\s+/g, '_')}_${FILE_SUFFIX[kind]}`

const LABEL_KEY: Record<
  RosterTransferDirection,
  Record<RosterTransferKind, string>
> = {
  import: {
    players: 'common:importPlayerRoster',
    teamOfficials: 'common:importTeamOfficialsRoster',
  },
  export: {
    players: 'common:exportPlayerRoster',
    teamOfficials: 'common:exportTeamOfficialsRoster',
  },
}

/** The i18n key for one menu entry — the Team screen's own keys. */
export const rosterTransferLabelKey = (
  direction: RosterTransferDirection,
  kind: RosterTransferKind
): string => LABEL_KEY[direction][kind]

export const parseRosterTransferKind = (
  key: string
): RosterTransferKind | null =>
  ROSTER_TRANSFER_KINDS.find((kind) => kind === key) ?? null
